// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"d234f450","64":"42da0739","199":"1c6acc04","278":"c1d9469e","362":"78d51145","403":"a4fb5b67","425":"7bada96d","453":"6d29fa34","519":"6e05c1af","551":"47721472","689":"576fb46e"}[chunkId] + ".chunk.js";
};